import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { CommonParamsType } from "constants/types/common";
import { SaleOrderParamsType } from "constants/types/salesOrder";
import { FC, useCallback } from "react";
import { useTableParams } from "utils/hooks/common/useTableParams";
import SalesOrderActions from "./components/SalesOrderActions/SalesOrderActions";
import SalesOrderTable from "./components/SalesOrderTable/SalesOrderTable";
import { SALES_ORDER_PAGE_TITLE } from "./config";

const SalesOrderWebLayout: FC = () => {
  const {
    params,
    setParams,
    handlePageChange,
    handleLimitChange,
    handleSearch,
  } = useTableParams<SaleOrderParamsType>();

  const handleFiltersChange = useCallback(
    (filters: Partial<Omit<SaleOrderParamsType, keyof CommonParamsType>>) => {
      setParams((prev) => ({ ...prev, ...filters, page: 1 }));
    },
    [setParams],
  );

  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: SALES_ORDER_PAGE_TITLE, href: "" }]} />
      <PageContent>
        <Stack gap="xs">
          <SalesOrderActions
            params={params}
            handleSearch={handleSearch}
            onFilterChange={handleFiltersChange}
          />
          <SalesOrderTable
            params={params}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default SalesOrderWebLayout;
